import React, { Component } from 'react';

class CardComponent extends Component {
    render() {
        return (
            <div className="card-component">
                <div className="col-md-12" style={{
                    backgroundColor: 'var(--card, #fff)',
                    border: '1px solid var(--border, #ccc)',
                    padding: 'calc(var(--spacing, 16px) * 6)',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 'var(--radius, 10px)',
                    boxShadow: 'var(--shadow-sm)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h4 style={{
                            color: 'var(--card-foreground, #000)',
                            fontWeight: '700',
                            marginBottom: '10px',
                            fontFamily: "var(--font-titles)"
                        }}>
                            Card title
                        </h4>
                        <a href="#!" className="focusable-element in-context-link-hover" style={{
                            color: 'var(--primary, #309AB5)',
                            fontWeight: '400',
                            borderBottom: 'none',
                            fontFamily: "var(--font-body)"
                        }}>Link button</a>
                    </div>
                    <p style={{ color: 'var(--card-foreground, #000)', fontFamily: "var(--font-body)" }}>
                        This is a card description with <a href="#!" style={{
                            color: 'var(--primary-button, #309AB5)',
                            textDecoration: 'underline',
                            fontFamily: "var(--font-body)"
                        }}>link text.</a>
                    </p>
                    <div className='row'>
                        <div className='col-md-5' style={{ borderRadius: '19px', overflow: 'hidden' }}>
                            <img style={{ borderRadius: 'var(--radius, 10px)' }}
                                className="roomView-card-img"
                                src="/public/images/aspect-ratio.png"
                                alt="Card view"
                            />
                        </div>
                        <div className='col-md-7' style={{ paddingLeft: '20px' }}>
                            <p style={{
                                color: 'var(--card-foreground, #000)',
                                marginBottom: '10px',
                                fontFamily: "var(--font-body)"
                            }}>
                                This is card text.
                            </p>
                            <ul>
                                <li style={{ color: 'var(--card-foreground, #000)', fontFamily: "var(--font-body)" }}>
                                    Card text with a <a href="#!" style={{
                                        color: 'var(--primary-button, #309AB5)',
                                        textDecoration: 'underline',
                                        fontFamily: "var(--font-body)"
                                    }}>link</a>
                                </li>
                                <li style={{ color: 'var(--card-foreground, #000)', fontFamily: "var(--font-body)" }}>
                                    Card text list item
                                </li>
                                <li style={{ color: 'var(--card-foreground, #000)', fontFamily: "var(--font-body)" }}>
                                    Card text list item
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="muted-container" style={{
                        marginTop: '16px',
                        backgroundColor: 'var(--muted, #E1E2E5)',
                        padding: 'calc(var(--spacing, 16px) * 6)',
                        borderRadius: 'var(--radius, 10px)',
                    }}>
                        <h4 style={{
                            color: 'var(--muted-foreground, #000)',
                            fontWeight: '700',
                            marginBottom: '10px',
                            fontFamily: "var(--font-titles)"
                        }}>
                            Muted container heading
                        </h4>
                        <span style={{
                            color: 'var(--muted-foreground, #000)',
                            marginBottom: '10px',
                            fontFamily: "var(--font-body)"
                        }}>
                            This is muted text.
                        </span>
                        <ul style={{ color: 'var(--muted-foreground, #000)', paddingLeft: 'calc(var(--spacing, 16px) * 2)' }}>
                            <li style={{ fontFamily: "var(--font-body)" }}>Muted text list item</li>
                            <li style={{ fontFamily: "var(--font-body)" }}>Muted text list item</li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardComponent;



// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/CardComponent.js